import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { handleGoogleLogin } from '../lib/auth';
import toast from 'react-hot-toast';

const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const processAuth = async () => {
      try {
        console.log('Auth callback page loaded');
        
        // Get the hash from the URL
        const hashParams = new URLSearchParams(window.location.hash.substring(1));
        const accessToken = hashParams.get('access_token');
        
        if (accessToken) {
          console.log('Access token found in URL');
        }
        
        // Check if we have a session
        const { data, error } = await supabase.auth.getSession();
        
        if (error) {
          console.error('Error getting session:', error);
          toast.error('Authentication failed');
          navigate('/login');
          return;
        }
        
        if (data.session) {
          console.log('Session found, processing login');
          const user = await handleGoogleLogin();
          
          if (user) {
            console.log('Login successful, redirecting to dashboard');
            toast.success('Login successful!');
            navigate('/dashboard');
          } else {
            console.error('No user data returned from handleGoogleLogin');
            toast.error('Failed to process login');
            navigate('/login');
          }
        } else {
          console.log('No session found, redirecting to login');
          navigate('/login');
        }
      } catch (error) {
        console.error('Error in auth callback:', error);
        toast.error('Authentication failed');
        navigate('/login');
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-black">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-yellow-400 mb-4"></div>
      <p className="text-white text-lg">Completing authentication...</p>
    </div>
  );
};

export default AuthCallback;